import type { Enum } from '@partou/core';

export const API_QUESTIONNAIRE_STATUSES = ['completed', 'in_progress', 'created', 'expired', 'deleted'] as const;

export type ApiQuestionnaireStatus = Enum<typeof API_QUESTIONNAIRE_STATUSES>;

export const NON_DELETED_QUESTIONNAIRE_STATUSES: ReadonlyArray<ApiQuestionnaireStatus> =
  API_QUESTIONNAIRE_STATUSES.filter((status: ApiQuestionnaireStatus): boolean => status !== 'deleted');
